const categories = [

    "business",
    "entertainment",
    "general",
    "health",
    "science",
    "sports",
    "technology",
 
];

export default categories;